<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Patient Name</th>
                        <th>Patient ID</th>
                        <th>Mobile No</th>
                        <th>Consultant Name</th>
                        <th v-if="isDoctor">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in bills" :key="i">
                        <td> {{ item.start_date_time }}</td>
                        <td> {{ item.contact_profile ? item.contact_profile.full_name : ''}}</td>
                        <td> {{ item.contact_profile ? item.contact_profile.serial_no : ''}}</td>
                        <td> {{ item.contact_profile ? item.contact_profile.mobile_no : ''}}</td>
                        <td> {{ item.service_resource ? item.service_resource.name : ''}}</td>
                        <td v-if="isDoctor">
                            <button @click="onClickToOpenService(item)" class="btn btn-secondary btn-sm">
                                <i class="fas fa-tooth"></i>
                                Dental Service
                            </button>
                        </td>
                    </tr>

                </tbody>
            </table>
            <p v-if="!bills.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import cloneDeep from "lodash/cloneDeep";
import { computed } from "vue";
import {useRoute, useRouter} from "vue-router";
import { useStore } from "vuex";

const props = defineProps({
    bills: Array
})

const route = useRoute();
const router = useRouter();
const store = useStore();

const isDoctor = computed(() => store.getters['user/isDoctor']);

const onClickToOpenService = (item) => {
    router.push({
        name: 'dental-service',
        params: {
            ...route.params,
            serviceId: item.id
        },
        query: {
            ...cloneDeep(route.query),
            back_url: encodeURIComponent(route.fullPath)
        }
    })
}
</script>
<style scoped>
.card--height {
  min-height: 200px
}
</style>
